export const lightTheme = {
  name: 'light',

  /* === Brand === */
  primaryColor: '#E91E63', // --primary-color
  primaryDark: '#C2185B', // --primary-dark
  secondaryColor: '#F48FB1', // --secondary-color,

  successColor: '#22c55e', // --success-color
  dangerColor: '#ef4444', // --danger-color
  warningColor: '#f59e0b', // --warning-color
  infoColor: '#f472b6', // --info-color

  /* === Backgrounds === */
  bgPrimary: '#ffffff', // --bg-primary
  bgSecondary: '#fff5fb', // --bg-secondary
  bgTertiary: '#ffe6f5', // --bg-tertiary

  background: '#d3c0cc', // --background
  cardBackground: '#ffffff', // --card-background
  hoverBackground: '#ffe6f5', // --hover-background

  /* === Text === */
  textPrimary: '#240524', // --text-primary
  textSecondary: '#930a83', // --text-secondary
  textMuted: '#704466', // --text-muted

  /* === Borders & Shadows === */
  borderColor: '#f7b9dd', // --border-color

  shadow: '0 1px 3px 0 rgba(0, 0, 0, 0.18), 0 1px 2px 0 rgba(0, 0, 0, 0.14)', // --shadow
  shadowLg:
    '0 10px 25px -5px rgba(233, 30, 99, 0.35), 0 8px 10px -6px rgba(0, 0, 0, 0.35)', // --shadow-lg

  primaryHover: '#D81557', // --primary-hover
  primaryStrong: '#AD1457', // --primary-strong (deep pink, gradient endpoint)
  accentColor: '#9C27B0', // --accent-color
  shadowMd:
    '0 4px 12px -2px rgba(233, 30, 99, 0.22), 0 2px 6px -1px rgba(0, 0, 0, 0.18)', // --shadow-md
  shadowXl:
    '0 20px 50px -10px rgba(233, 30, 99, 0.4), 0 12px 20px -8px rgba(0, 0, 0, 0.4)', // --shadow-xl
  shadowSoft: 'rgba(233, 30, 99, 0.12)', // --shadow-soft

  /* === Messaging / States === */
  primaryLight: 'rgba(233, 30, 99, 0.14)', // --primary-light
  unreadBackground: 'rgba(233, 30, 99, 0.06)', // --unread-background
  messageBubbleBg: '#ffe6f5', // --message-bubble-bg
  messageReceivedBg: '#ffffff', // --message-received-bg
  dangerLight: 'rgba(239, 68, 68, 0.1)', // --danger-light,
};

export const darkTheme = {
  name: 'dark',

  /* === Brand === */
  primaryColor: '#F06292', // --primary-color
  primaryDark: '#E91E63', // --primary-dark
  secondaryColor: '#F48FB1', // --secondary-color

  successColor: '#22c55e',
  dangerColor: '#ef4444',
  warningColor: '#f59e0b',
  infoColor: '#f472b6',

  /* === Backgrounds === */
  bgPrimary: '#050109', // --bg-primary
  bgSecondary: '#090212', // --bg-secondary
  bgTertiary: '#160817', // --bg-tertiary

  background: '#050109', // --background
  cardBackground: '#090212', // --card-background
  hoverBackground: '#160817', // --hover-background

  /* === Text === */
  textPrimary: '#ffe9fb', // --text-primary
  textSecondary: '#f6b4dd', // --text-secondary
  textMuted: '#f086c4', // --text-muted

  /* === Borders & Shadows === */
  borderColor: '#F06292', // --border-color

  shadow: '0 1px 3px 0 rgba(240, 98, 146, 0.4), 0 1px 2px 0 rgba(0, 0, 0, 0.8)', // --shadow
  shadowLg:
    '0 18px 35px -10px rgba(0, 0, 0, 0.9), 0 0 40px rgba(240, 98, 146, 0.35)', // --shadow-lg

  primaryHover: '#F48FB1', // --primary-hover
  primaryStrong: '#FF4081', // --primary-strong (bright pink, gradient endpoint)
  accentColor: '#CE93D8', // --accent-color
  shadowMd:
    '0 4px 12px -2px rgba(240, 98, 146, 0.3), 0 2px 6px -1px rgba(0, 0, 0, 0.6)', // --shadow-md
  shadowXl:
    '0 28px 60px -14px rgba(0, 0, 0, 0.9), 0 0 60px rgba(240, 98, 146, 0.4)', // --shadow-xl
  shadowSoft: 'rgba(240, 98, 146, 0.2)', // --shadow-soft

  /* === Messaging / States === */
  primaryLight: 'rgba(240, 98, 146, 0.3)', // --primary-light
  unreadBackground: 'rgba(240, 98, 146, 0.16)', // --unread-background
  messageBubbleBg: '#160817', // --message-bubble-bg
  messageReceivedBg: '#221025', // --message-received-bg
  dangerLight: 'rgba(239, 68, 68, 0.25)', // --danger-light,
};

export const themes = {
  light: lightTheme,
  dark: darkTheme,
};
